import React from 'react'
import { Button } from 'react-bootstrap'
import useClientLocation from '../../../hooks/use-client-location'

const EditButton = ({
    goal,
    ...props
}) => {
    const { toUserGoal } = useClientLocation()

    return (
        <React.Fragment>
            <Button onClick={() => toUserGoal(goal.userId, goal.id)} {...props} />
        </React.Fragment>
    )
}

export default EditButton